import Loader from '@assets/images/loader-3-dots.svg?react'
import type React from 'react'

import { AttachedFileWrapper } from '../AttachedFileWrapper'
import css from './LoadingAttachment.module.scss'

interface Props {
  selected: boolean
}

export const LoadingFile: React.FC<Props> = ({ selected }) => (
  <AttachedFileWrapper selected={selected}>
    <div className={css.container}>
      <Loader />
    </div>
  </AttachedFileWrapper>
)
